import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { updateLoyaltyProgramApi } from './updateLoyaltyProgram.api'
import updateLoyaltyProgramInitialState from './updateLoyaltyProgram.initialState'
import { UpdateLoyaltyProgramErrorResponse, UpdateLoyaltyProgramRequestPayload } from './updateLoyaltyProgram.types'

export const updateLoyaltyProgram = createAsyncThunk(
  urls.profile.updateLoyaltyProgram,
  async (payload: UpdateLoyaltyProgramRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await updateLoyaltyProgramApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const updateLoyaltyProgramSlice = createSlice({
  name: urls.profile.updateLoyaltyProgram,
  initialState: updateLoyaltyProgramInitialState,
  reducers: {
    resetUpdateLoyaltyProgram: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateLoyaltyProgram.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(updateLoyaltyProgram.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(updateLoyaltyProgram.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as UpdateLoyaltyProgramErrorResponse
        state.success = null
      })
  }
})

export const { actions: updateLoyaltyProgramActions, reducer: updateLoyaltyProgramReducer } = updateLoyaltyProgramSlice
export const { resetUpdateLoyaltyProgram } = updateLoyaltyProgramActions
export default updateLoyaltyProgramSlice.reducer
